import { connect } from 'react-redux';
import {
  compose, withHandlers, withProps, withState, lifecycle,
} from 'recompose';

import withCost from './withCost';
import CheckoutModal from '../components/CheckoutModal';
import withRouteParameters from './withRouteParameters';
import { getTipEnabledForBarber } from '../../barbers/selectors';
import { getIsPayFacShop, getNoExtrasForReserveNoPay } from '../../shops/selectors';
import { getAppointmentId, getIsValidatingAppointment } from '../selectors';
import analytics from '../../applicationServices/analytics/BookingAnalytics';
import { ValidateAppointmentContainer } from './ValidateAppointment';

export default compose(
  ValidateAppointmentContainer,
  withRouteParameters,
  connect(
    (state, ownProps) => {
      const tipEnabledForBarber = getTipEnabledForBarber(state, ownProps.barberRoute);
      const noExtrasForReserveNoPay = getNoExtrasForReserveNoPay(state, ownProps.shopRoute);
      const onChargeAppointment = !!getAppointmentId(state);
      const isValidating = getIsValidatingAppointment(state);

      return {
        tipEnabled: tipEnabledForBarber && (noExtrasForReserveNoPay || onChargeAppointment) && !ownProps.kiosk,
        isPayFacBrand: getIsPayFacShop(state, ownProps.shopRoute),
        isValidating,
      };
    },
  ),
  withCost,
  withState('setupIntent', 'setSetupIntent', null),
  withHandlers({
    confirmSetup: props => (token) => {
      const result = props.onSuccess(token);
      if (props.off) {
        props.off();
      }
      return result;
    },
    off: props => () => {
      analytics.abandonPayment({ source: 'squire_modal' });
      props.off();
    },
  }),
  withProps(props => ({
    formDisabled: props.disabled || props.isValidating,
  })),
  lifecycle({
    componentDidUpdate(prevProps) {
      // trigger only when a modal turns from closed to opened
      if (this.props.toggled && !prevProps.toggled) {
        this.props.validate();
        analytics.showSquireModal();
        analytics.startPayment({ source: 'squire_modal' });
      }
    },
  }),
)(CheckoutModal);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/CheckoutModal.js